angular.module('unica_feedback_category.feedback_category_services')

.factory('FeedbackCategoryDeleteService', function ($http, getBaseApiURL) {

	var feedbackCategoryDeleteService = {};

	feedbackCategoryDeleteService.delete = function (feedbackCategoryId)
	{
		return $http({
			method: 'DELETE',
			url: getBaseApiURL + '/feedback-category/delete/' + feedbackCategoryId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};

	return feedbackCategoryDeleteService;
});